
import React from 'react';
import { t } from '@superset-ui/core';
import {
    ControlPanelConfig,
    sections,
    sharedControls,
    ControlStateMapping,
    emitFilterControl,
} from '@superset-ui/chart-controls';
import { DEFAULT_FORM_DATA } from './types';
import { legendSection } from '../../../controls';
import { commonControlsConfig } from '../utils';

const { showLabels } = DEFAULT_FORM_DATA;

const chartLegendSection = [...legendSection];
chartLegendSection.splice(2, 1);
 
const config: ControlPanelConfig = {
   controlPanelSections: [
    {
      ...sections.legacyRegularTime,
      expanded: false
    },
     {
       label: t('Query'),
       expanded: true,
       controlSetRows: [
        ['metric'],
        ['adhoc_filters'],
        emitFilterControl,
        [
          {
            name: 'row_limit',
            config: {
              ...sharedControls.row_limit,
              choices: [...Array(10).keys()].map(n => n + 1),
              default: DEFAULT_FORM_DATA.rowLimit,
            },
          },
        ],
       ],
     },
     {
       label: t('Chart Options'),
       tabOverride: 'customize',
       expanded: false,
       controlSetRows: [
        //  ['color_scheme'],
         ...chartLegendSection,
         // eslint-disable-next-line react/jsx-key
         [<div className="section-header">{t('Labels')}</div>],
         [
           {
             name: 'show_labels',
             config: {
               type: 'CheckboxControl',
               label: t('Show Labels'),
               renderTrigger: true,
               default: showLabels,
               description: t('Whether to display the labels.'),
             },
           },
         ],

         [
          {
            name: 'rangeMin',
            config: {
              ...commonControlsConfig.number,
              label: t('Gauge Min value'),
              description: t(
                'Minimum value for Gauge.',
              ),
              default: DEFAULT_FORM_DATA.rangeMin,
              renderTrigger: true,
            },
          }
        ],
        [
          {
            name: 'rangeMax',
            config: {
              ...commonControlsConfig.number,
              label: t('Gauge Max value'),
              description: t(
                'Maximum value for Gauge.',
              ),
              default: DEFAULT_FORM_DATA.rangeMax,
              renderTrigger: true,
            },
          }
        ],
        
        [
          {
            name: 'valueFormat',
            config: {
              ...commonControlsConfig.valueFormat,
              default: DEFAULT_FORM_DATA.valueFormat,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'threshold1',
            config: {
              ...commonControlsConfig.percentage,
              label: t('First Threshold (%)'),
              description: t(
                'Threshold for first stage as a percentage.',
              ),
              default: DEFAULT_FORM_DATA.threshold1,
              renderTrigger: true,
            },
          }
        ],
         [
          {
            name: 'stageColor1',
            config: {
              ...sharedControls.color_picker,
              label: t('Stage 1 Color'),
              default: DEFAULT_FORM_DATA.stageColor1,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'threshold2',
            config: {
              ...commonControlsConfig.percentage,
              label: t('Second Threshold (%)'),
              description: t(
                'Threshold for second stage as a percentage.',
              ),
              default: DEFAULT_FORM_DATA.threshold2,
              renderTrigger: true,
            },
          }
        ],
         [
          {
            name: 'stageColor2',
            config: {
              ...sharedControls.color_picker,
              label: t('Stage 2 Color'),
              default: DEFAULT_FORM_DATA.stageColor2,
              renderTrigger: true,
            },
          }
         ],
         [
          {
            name: 'stageColor3',
            config: {
              ...sharedControls.color_picker,
              label: t('Stage 3 Color'),
              default: DEFAULT_FORM_DATA.stageColor3,
              renderTrigger: true,
            },
          }
         ],
       ],
     },
   ],
   onInit(state: ControlStateMapping) {
     return {
       ...state,
       row_limit: {
         ...state.row_limit,
         value: state.row_limit.default,
       },
     };
   },
   denormalizeFormData: formData => ({
     ...formData,
     metric: formData.standardizedFormData.standardizedState.metrics[0],
     groupby: formData.standardizedFormData.standardizedState.columns,
   }),
   updateStandardizedState: (prevState, currState) => ({
     ...currState,
     metrics: [currState.metrics[0], ...prevState.metrics.slice(1)],
   }),
};
 
export default config;
 